<template>
  <div class="flex">
    <div class="top-left-btn">
      <el-row :gutter="10" class="mb8">
        <!--表格左侧操作区-->
        <slot name="tableOperation" />
      </el-row>
    </div>
    <!--表格右侧操作区-->
    <div class="top-right-btn">
      <el-row>
        <el-tooltip class="item" effect="dark" :content="vm.$t('settingText')" placement="top">
          <el-button circle icon="el-icon-setting" @click="showSetting()" />
        </el-tooltip>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PurchaseRightToolbar',
  props: {
  },
  data() {
    return {
      vm: window.vm,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    /** START 以下配合 ElementTableSortable 插件 */
    // 设置
    showSetting() {
      this.$emit('showSetting');
    },
    /** END */
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.top-right-btn {
  margin-bottom: 10px;
}
@media (max-width: 550px) {
  .flex {
    display: block;
  }
}
</style>
